import { render } from "./vfileclassifyedit.vue?vue&type=template&id=63e4cc48&scoped=true"
import script from "./vfileclassifyedit.vue?vue&type=script&lang=js"
export * from "./vfileclassifyedit.vue?vue&type=script&lang=js"

import "./vfileclassifyedit.vue?vue&type=style&index=0&id=63e4cc48&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e4cc48"]])

export default __exports__